import { render, staticRenderFns } from "./ServicesTable.vue?vue&type=template&id=08e4ef64&scoped=true"
import script from "./ServicesTable.vue?vue&type=script&lang=js"
export * from "./ServicesTable.vue?vue&type=script&lang=js"
import style0 from "./ServicesTable.vue?vue&type=style&index=0&id=08e4ef64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e4ef64",
  null
  
)

export default component.exports